import React, { useState } from "react";
import Button from "../../shared/Button/Button";
import styles from "./Form.module.scss";
import { useForm } from "react-hook-form";
import server from "../../../api/server";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Container, Row } from "react-bootstrap";
import { useRouter } from "next/router";

export default function Form() {
  const { locale } = useRouter();
  const intl = useIntl();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const res = await server.post("/api/contact", data);
      if (res.data.status === "success") {
        setFormSubmitted(true);
        reset();
        setTimeout(() => {
          setFormSubmitted(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Form submission failed", error);
    }
  };

  const isRtl = locale === "ar";

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles["contact-box"]}>
        <div className={styles["text"]}>
          <h3>
            <FormattedMessage id="have-question" />
          </h3>
          <p>
            <FormattedMessage id="have-question-desc" />
          </p>
        </div>
        <Row dir={locale === "ar" ? "rtl" : "ltr"}>
          <Col xs={12} md={6}>
            <div className={styles["input-group"]}>
              <label>
                <FormattedMessage id="name" />
              </label>
              <input
                {...register("name", {
                  required: intl.formatMessage({ id: "required" }),
                  minLength: {
                    value: 2,
                    message: intl.formatMessage({ id: "min-length" }),
                  },
                })}
                placeholder={intl.formatMessage({ id: "name" })}
                type="text"
              />
              {errors.name && (
                <p className={styles["error-text"]}>{errors.name.message}</p>
              )}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className={styles["input-group"]}>
              <label>
                <FormattedMessage id="last" />
              </label>
              <input
                {...register("last_name", {
                  required: intl.formatMessage({ id: "required" }),
                  minLength: {
                    value: 2,
                    message: intl.formatMessage({ id: "min-length" }),
                  },
                })}
                placeholder={intl.formatMessage({ id: "last" })}
                type="text"
              />
              {errors.last_name && (
                <p className={styles["error-text"]}>
                  {errors.last_name.message}
                </p>
              )}
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div className={styles["input-group"]}>
              <label>
                <FormattedMessage id="phone" />
              </label>
              <input
                {...register("phone", {
                  required: intl.formatMessage({ id: "required" }),
                  pattern: {
                    value: /^\d+$/,
                    message: intl.formatMessage({ id: "invalid-phone" }),
                  },
                  minLength: {
                    value: 8,
                    message: intl.formatMessage({ id: "min-length" }),
                  },
                })}
                placeholder={intl.formatMessage({ id: "phone" })}
              />
              {errors.phone && (
                <p className={styles["error-text"]}>{errors.phone.message}</p>
              )}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className={styles["input-group"]}>
              <label>
                <FormattedMessage id="mail" />
              </label>
              <input
                {...register("email", {
                  required: intl.formatMessage({ id: "required" }),
                  pattern: {
                    value: /^\S+@\S+\.\S+$/,
                    message: intl.formatMessage({ id: "invalid-email" }),
                  },
                  minLength: {
                    value: 8,
                    message: intl.formatMessage({ id: "min-length" }),
                  },
                })}
                placeholder={intl.formatMessage({ id: "mail" })}
                type="email"
              />
              {errors.email && (
                <p className={styles["error-text"]}>{errors.email.message}</p>
              )}
            </div>
          </Col>
          <Col xs={12}>
            <div className={styles["input-group"]}>
              <label>
                <FormattedMessage id="massage" />
              </label>
              <textarea
                {...register("massage", {
                  required: intl.formatMessage({ id: "required" }),
                })}
                placeholder={intl.formatMessage({ id: "massage" })}
                cols="100"
                rows="5"
              ></textarea>
              {errors.massage && (
                <p className={styles["error-text"]}>{errors.massage.message}</p>
              )}
            </div>
          </Col>
        </Row>
        <div className={styles["button-wrapper"]}>
          <button type="submit" className={styles["cta-button-red"]}>
            <FormattedMessage id="contact-us" />

            <div className={styles["icon-circle"]}>
              <svg
                style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.53577 3.53556L14.1424 14.1422"
                  stroke="black"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                  stroke="black"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
        </div>

        {formSubmitted && (
          <strong className="mt-4 d-block text-center">
            <FormattedMessage id="form-message" />
          </strong>
        )}
      </div>
    </form>
  );
}
